import get from 'lodash/get'
import {getChatUrlByRoomId} from 'utils/url.utils'

export const WHATSAPP_BASE_LINK = 'https://wa.me'

export function getSharingText(room, pin) {
  const roomId = get(room, 'uid')
  const description = get(room, 'description')
  const creatorName = get(room, 'creator.name')
  const chatUrl = getChatUrlByRoomId(roomId)

  return `Chat with ${creatorName} about "${description}"\r\n${chatUrl}\r\nPIN: ${pin}`
}

export function getWhatsAppSharingLink(room, pin) {
  const text = encodeURIComponent(getSharingText(room, pin))
  return `${WHATSAPP_BASE_LINK}/?text=${text}`
}

export function getEmailSharingLink(room, pin) {
  const text = getSharingText(room, pin)
  const body = encodeURIComponent(`${text}\r\n--\r\nreden.me`)
  const subject = encodeURIComponent('Chat Invitation - reden.me')
  return `mailto:?subject=${subject}&body=${body}`
}
